import styled from "styled-components";
import { setFlex, setPosition } from "../../variables/Position";
import { COLOURS } from "../../variables/Colors";
import { BREAKPOINTS } from "../../variables/Breakpoints";

export const GalleryWrapper = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({ direction: "column" })};
  width: 100%;
  margin-top: 3rem;
`;

export const TextContainer = styled.div`
  ${props => setFlex({ justify: props.$justify })};
  width: 100%;
  height: 100%;
  @media (max-width: ${BREAKPOINTS.lg}px) {
    ${setPosition({ position: "absolute" })};
  }
`;

export const CoordinateText = styled.p`
  font-family: "overpass-regular";
  font-size: 0.8rem;
  line-height: 0.8rem;
  color: ${COLOURS.primary.yellow};
  margin: 0;
  text-decoration: underline;
  text-underline-offset: 5px;
  @media (max-width: ${BREAKPOINTS.sm}px) {
    font-size: 0.5rem;
  }
`;

export const ImageContainer = styled.div`
  ${props =>
    setFlex({
      justify: props.$justify,
    })};
  width: 100%;
  ${props => props.$margin && "margin-bottom: 3rem"};
`;

export const Image = styled.img`
  max-width: 100%;
  max-height: ${props => (props.$fullWidth ? "100vh" : "80vh")};
  width: auto;
`;
